import React from 'react';
import './Sidebar.css';
import CategoryIcon, { icons } from './CategoryIcon';

const Sidebar = ({ categories, activeCategory, onCategoryClick, isSidebarOpen, setIsSidebarOpen, categorySongCounts, config }) => {
  return (
    <nav
      className={`sidebar-nav${isSidebarOpen ? ' open' : ''}`}
      aria-label="Category navigation"
    >
      {/* Header */}
      <div className="sidebar-header">
        <button
          className="sidebar-close"
          onClick={() => setIsSidebarOpen(false)}
          aria-label="Close menu"
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
            <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
          </svg>
        </button>
        <div className="sidebar-brand-icon">✝</div>
        <h2 className="sidebar-title">{config?.app?.name || 'இதய ராகம்'}</h2>
        <p className="sidebar-subtitle">{config?.app?.subtitle || 'Idhaya Ragam'}</p>
      </div>

      {/* Category list */}
      <div className="sidebar-content">
        {categories
          .filter(category => category.id !== 'home')
          .map((category) => (
            <button
              key={category.id}
              className={`category-button${activeCategory === category.id ? ' active' : ''}`}
              onClick={() => onCategoryClick(category.id)}
              title={category.title}
            >
              <span className="category-icon">
                {icons[category.id] ? (
                  <CategoryIcon categoryId={category.id} size={24} />
                ) : category.icon?.startsWith('/') ? (
                  <img src={category.icon} alt={category.title} className="category-icon-img" />
                ) : (
                  category.icon
                )}
              </span>
              <span className="category-title">{category.title}</span>
              {config?.ui?.showSongCount && category.songFile && (
                <span className="category-count">
                  {categorySongCounts[category.id] !== undefined ? categorySongCounts[category.id] : '…'}
                </span>
              )}
            </button>
          ))}
      </div>
    </nav>
  );
};

export default Sidebar;
